export const HEADER = 1000
export const MODAL = 9999
